import { DefaultTheme } from 'styled-components';

const theme: DefaultTheme = {
  notThisMonthColor: '#BFBFBF',
  sundayColor: '#FB2D08',
  borderColor: '#D7D7D7',
};

export default theme;
